import React from "react";

export const VerifyCheckIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="32" fill="#E5FAEF" />
    <path
      d="M28.7 36.4333L40.2667 24.8667C40.5111 24.6222 40.7889 24.5 41.1 24.5C41.4333 24.5 41.7222 24.6222 41.9667 24.8667C42.2111 25.1111 42.3333 25.4111 42.3333 25.7667C42.3333 26.1 42.2111 26.3889 41.9667 26.6333L29.5333 39.0667C29.2889 39.3111 29 39.4333 28.6667 39.4333C28.3556 39.4333 28.0778 39.3111 27.8333 39.0667L22 33.2333C21.7556 32.9889 21.6333 32.7 21.6333 32.3667C21.6556 32.0333 21.7889 31.7444 22.0333 31.5C22.2778 31.2556 22.5667 31.1333 22.9 31.1333C23.2333 31.1333 23.5222 31.2556 23.7667 31.5L28.7 36.4333Z"
      fill="#00CC66"
    />
  </svg>
);
